import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a613512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-list material-card_type_outlined" }

import { IMenuListProps } from './menu-list.types';

import MenuListItem from './menu-list-item.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'menu-list',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.items, (item) => {
      return (_openBlock(), _createBlock(MenuListItem, {
        key: item.title,
        props: item
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})